'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$IngredientsAppPage$() {
}
export { $c_Lmealorama_AppRouter$IngredientsAppPage$ as $c_Lmealorama_AppRouter$IngredientsAppPage$ };
$p = $c_Lmealorama_AppRouter$IngredientsAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$IngredientsAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$IngredientsAppPage$() {
}
export { $h_Lmealorama_AppRouter$IngredientsAppPage$ as $h_Lmealorama_AppRouter$IngredientsAppPage$ };
$h_Lmealorama_AppRouter$IngredientsAppPage$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1369512626);
});
$p.m = (function() {
  return "IngredientsAppPage";
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "IngredientsAppPage";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
var $d_Lmealorama_AppRouter$IngredientsAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$IngredientsAppPage$, "mealorama.AppRouter$IngredientsAppPage$", ({
  Fs: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_AppRouter$IngredientsAppPage$ as $d_Lmealorama_AppRouter$IngredientsAppPage$ };
var $n_Lmealorama_AppRouter$IngredientsAppPage$;
function $m_Lmealorama_AppRouter$IngredientsAppPage$() {
  if ((!$n_Lmealorama_AppRouter$IngredientsAppPage$)) {
    $n_Lmealorama_AppRouter$IngredientsAppPage$ = new $c_Lmealorama_AppRouter$IngredientsAppPage$();
  }
  return $n_Lmealorama_AppRouter$IngredientsAppPage$;
}
export { $m_Lmealorama_AppRouter$IngredientsAppPage$ as $m_Lmealorama_AppRouter$IngredientsAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Ingredients-App-Page$.js.map
